import arrayBuffer2BinStr from './arrayBuffer2BinStr';

export default function arrayBufferToBase64(buffer: ArrayBuffer) {
  const encryptedBinStr = arrayBuffer2BinStr(buffer);
  return window.btoa(encryptedBinStr);
}
